import { Copy, Edit, Eye, X } from 'lucide-react';
import { useContext, useState } from 'react';
import { ProgramContext } from '../../context/ProgramsContext';
import { Tooltip } from '@mui/material';
import { CheckCircle, XCircle, AlertCircle, MinusCircle, Clock } from "lucide-react"; // or any other icons you prefer

const ActivityChip = ({ activity, dayId, onToggleState, onDeleteActivity, onDuplicateActivity, onDragStart, onDragEnd, onDrop, isLocked, draggedActivity, setDraggedActivity, ...props }) => {

  const {
    ACTIVITY_TYPES,
    ACTIVITY_STATES,
    setEditPtSession,
    setViewPtSession,
    setViewRomTest,
    setEditROMTest
  } = useContext(ProgramContext)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const typeInfo = ACTIVITY_TYPES[activity.type];
  const stateInfo = activity.state ? ACTIVITY_STATES[activity.state] : null;
  const isPartial = activity?.activities?.some((e) => e?.is_complete === 1 || e?.is_skipped === 1)
  const detailsText = () => {
    if (activity.type === 'PT_SESSION') return `${activity.estTime} min / ${activity.exerciseCount} exercises`;
    if (activity.type === 'ROM_TEST') return `${activity.exercises?.length || 0} exercises`;
    if (activity.estTime) return `Est. ${activity.estTime} min`;
    if (activity.readTime) return `Read: ${activity.readTime} min`;
    if (activity.videoLength) return `Video: ${activity.videoLength} min`; return typeInfo?.name;
  };


  const typeBgClass = {
    PT_SESSION: 'bg-[#166273]/10 hover:bg-[#166273]/20',
    ROM_TEST: 'bg-blue-100 hover:bg-blue-200',
    EDUCATION: 'bg-yellow-100 hover:bg-yellow-200',
    QUESTIONNAIRE: 'bg-purple-100 hover:bg-purple-200',
  };

  const typeClass = isLocked
    ? 'bg-gray-200'
    : typeBgClass[activity.type] || 'bg-gray-100 hover:bg-gray-200';

  const getActivityIcon = () => {
    if (activity.is_incomplete) {
      return { icon: XCircle, color: "text-red-500", label: "Incomplete" };
    } else if (activity.is_complete) {
      return { icon: CheckCircle, color: "text-green-600", label: "Completed" };
    } else if (activity.is_skipped) {
      return { icon: MinusCircle, color: "text-yellow-500", label: "Skipped" };
    } else if (isPartial) {
      return { icon: AlertCircle, color: "text-orange-500", label: "Partially Completed" };
    } else {
      return { icon: Clock, color: "text-gray-500", label: "Pending" };
    }
  };

  const { icon: Icon, color, label } = getActivityIcon();

  return (
    <div
      draggable={!isLocked && label === "Pending"}
      onDragStart={
        isLocked ? null : (e) => {
          setDraggedActivity({ ...activity, sourceDayId: dayId });
          e.dataTransfer.effectAllowed = 'move';
        }}
      onDragEnd={isLocked ? null : onDragEnd}
      onDrop={
        isLocked
          ? null
          :
          (e) => {
            e.preventDefault();
            if (!draggedActivity || draggedActivity.sourceDayId !== dayId) return;

            if (draggedActivity.id === activity.id) return; // prevent dropping on self

            props.reorderActivityWithinDay(dayId, draggedActivity.id, activity.id);
          }}
      onDragOver={isLocked ? null : (e) => e.preventDefault()}
      className={`relative group/card-hover flex items-start p-2.5 mb-2 rounded-lg shadow-md group ${isLocked ? 'opacity-80' : 'cursor-grab'} ${typeClass}`}
    >
      {stateInfo && (
        <Tooltip
          title={label}
          arrow
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={`flex-shrink-0 mr-2.5 mt-0.5`}
          >
            <Icon
              size={18}
              className={`bg-white rounded-full p-0.5 border border-gray-300 ${color}`}
            />
          </button>
        </Tooltip>
      )}

      <div className="flex-grow">
        <p className="font-bold text-sm text-gray-800 leading-tight">{activity.title}</p>
        <p className="text-xs text-gray-600 pt-1">{detailsText()}</p>
      </div>


      <div className="absolute top-1 right-1 flex items-center space-x-1 opacity-0 group-hover/card-hover:opacity-100 transition-opacity">
        {
          (activity.type === 'ROM_TEST' || activity.type === 'PT_SESSION')
          &&
          <button
            onClick={() => {
              console.log("activity.type", activity.type)
              if (activity.type === 'PT_SESSION') {
                setViewPtSession(activity)
              }
              if (activity.type === 'ROM_TEST') {
                setViewRomTest(activity)
              }
            }
            }
            className="p-0.5 bg-gray-200 rounded-full text-gray-700 hover:bg-gray-300"
          >
            <Eye size={12} />
          </button>
        }
        {!isLocked && (
          <>
            {(activity.type === 'PT_SESSION' || activity.type === "ROM_TEST") &&
              <button
                onClick={() => {
                  if (activity.type === 'PT_SESSION') {
                    setEditPtSession(activity)
                  } else if (activity.type === 'ROM_TEST') {
                    setEditROMTest(activity)
                  }
                }
                }
                disabled={activity?.is_complete || activity?.is_skipped || activity.is_incomplete || isPartial}
                className="p-0.5 bg-gray-200 rounded-full text-gray-700 hover:bg-gray-300 disabled:cursor-[not-allowed]"
              >
                <Edit size={12} />
              </button>
            }
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDuplicateActivity(activity.id, dayId);
              }}
              // disabled={activity?.is_complete || activity?.is_skipped || activity.is_incomplete}
              className="p-0.5 bg-gray-200 rounded-full text-gray-700 hover:bg-gray-300"
            >
              <Copy size={12} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirm(true);
                // onDeleteActivity(activity.id, dayId);
              }}
              disabled={activity?.is_complete || activity?.is_skipped || activity.is_incomplete || isPartial}
              className="p-0.5 bg-gray-200 rounded-full text-gray-700 hover:bg-red-200 disabled:cursor-[not-allowed]"
            >
              <X size={12} />
            </button>
          </>
        )}
      </div>


      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-sm animate-fade-in-up">
            <h2 className="text-lg font-bold text-gray-800 mb-2">Delete Activity</h2>
            <p className="text-gray-600 mb-4">Are you sure you want to delete <strong>{activity.title}</strong>?</p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  onDeleteActivity(activity.id, dayId);
                  setShowDeleteConfirm(false);
                }}
                className="px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white font-semibold"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivityChip;